import { LogDeviceModel } from '../../models/log-device.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { RequestService } from '../request/request-onboarding.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { NavigationService } from '../navigation/navigation-onboarding.service';
import * as i0 from "@angular/core";
import * as i1 from "../abre-cuentas/abre-cuentas.service";
import * as i2 from "../request/request-onboarding.service";
import * as i3 from "../external/biocatch/biocatch.service";
import * as i4 from "../navigation/navigation-onboarding.service";
/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var BitacoraService = /** @class */ (function () {
    /**
     * Constructor de la clase
     *
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los servicios
     *
     * *Initialize method for services*
     *
     * @param {CopyService}    copyService    Injectable copyService service.
     * @param {RequestService} requestService Injectable abreCuentasService service.
     */
    function BitacoraService(abreCuentasService, requestService, bioCatchService, navigationService) {
        this.abreCuentasService = abreCuentasService;
        this.requestService = requestService;
        this.bioCatchService = bioCatchService;
        this.navigationService = navigationService;
    }
    /**
     * Guarda el log del dispositivo en la bitácora de la apliación
     *
     * *Saves device log in app bitacora*
     *
     * @param {LogDeviceModel} devicePrint
     */
    BitacoraService.prototype.saveDataInBitacora = function (eventName, isCSID, crypto) {
        var _this = this;
        if (isCSID === void 0) { isCSID = false; }
        if (crypto === void 0) { crypto = false; }
        try {
            var devicePrint = new LogDeviceModel();
            console.log('this.abreCuentasService.getproductSelected()', this.abreCuentasService.getproductSelected());
            var product_name = this.abreCuentasService.getproductSelected() ? this.abreCuentasService.getproductSelected().product_code : '';
            devicePrint.device = this.abreCuentasService.getDeviceInfo();
            var ipBiocatch = this.bioCatchService.getCurrentScoreIp();
            var frontmicro = 'onboarding-angular-fe';
            devicePrint.device.event_name = eventName;
            devicePrint.transaction = this.abreCuentasService.getTransactionInfo();
            devicePrint.transaction.transaction_type = frontmicro;
            devicePrint.device.ip = ipBiocatch;
            devicePrint.terms_type = eventName;
            this.requestService.saveDataInBitacora(devicePrint, isCSID, crypto)
                .then(function () { return eventName === 'exit_process' && _this.navigationService.goToLoginPage(); })
                .catch(function () { return eventName === 'exit_process' && _this.navigationService.goToLoginPage(); });
        }
        catch (error) {
            console.log(error);
        }
    };
    BitacoraService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BitacoraService_Factory() { return new BitacoraService(i0.ɵɵinject(i1.AbreCuentasService), i0.ɵɵinject(i2.RequestService), i0.ɵɵinject(i3.BioCatchService), i0.ɵɵinject(i4.NavigationService)); }, token: BitacoraService, providedIn: "root" });
    return BitacoraService;
}());
export { BitacoraService };
